// Stub — filled in by sub-spec 12 (Capacitor staff app).
// On the web app this module is never selected (transport selector picks
// transport_web_bluetooth.ts based on the absence of Capacitor in window).

const NOT_AVAILABLE =
  'Capacitor printer transport ships in sub-spec 12. Use the web app on Chrome/Edge desktop for now.';

export async function pairPrinter(): Promise<{ deviceId: string; name: string }> {
  throw new Error(NOT_AVAILABLE);
}

export async function unpairPrinter(): Promise<void> {
  throw new Error(NOT_AVAILABLE);
}

export async function getPairedPrinter(): Promise<{ deviceId: string; name: string } | null> {
  return null;
}

export async function printBytes(_bytes: Uint8Array): Promise<void> {
  throw new Error(NOT_AVAILABLE);
}

export async function kickDrawer(): Promise<void> {
  throw new Error(NOT_AVAILABLE);
}
